// extracted by mini-css-extract-plugin
module.exports = {"grid":"account-modal__grid","header":"account-modal__header","subheader":"account-modal__subheader","button":"account-modal__button"};